import { firestore, serverTimestamp } from '../firebase';
import { mp } from '../mixpanel';

export default async function createNewConsultAcne(user, router) {
  // create a new consult

  const ref = firestore.collection('consultations').doc();
  // Data to be inserted
  const insertData = {
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    treatment: 'Acne',
    type: 'initial', // 'initial' or 'renewal' // the renewal request can be for the same of a diff drug
    userID: user.uid,
    preferredShippingFillsPerOrder: null, // user chooses this during checkout - e.g. wants to have their meds shipped every 2 months
    status: 'in progress',
    paid: false, // delete this?
    path: [1],
  };
  // Insert data in new consult
  await ref.set(insertData);

  // Get the ID of that new consult
  // Redirect user to the new consult
  const consultation = await ref.get();
  mp.track('consult_created_acne', {
    userID: user.uid,
    consultID: ref.id,
  });
  router.push(`/acne/consultation/${consultation.id}`);
}
